module.exports = __webpack_public_path__ + "static/media/AW.fcd7c184.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AW.svg
// module id = 2104
// module chunks = 7